module.exports = __webpack_public_path__ + "img/8d8ae865dc794dab9ead8682881788de-60.0115262e.png";